<template>
  <div class='history-detail'>
    <div>
      <div data-v-6be92187="" class="history-popper-header">
        <div data-v-6be92187="" class="ivu-row-flex ivu-row-flex-space-between">
          <div data-v-6be92187="" class="ivu-col">
            <div data-v-6be92187="" class="ivu-row-flex">
              <b data-v-6be92187="" class="history-title">
                {{ roundData.name }}
              </b>
            </div>
            <div data-v-6be92187="" class="ivu-row">
              <div data-v-6be92187="" class="history-draw-no">
                {{ $t('no.') }} {{ roundData.round }}
              </div>
            </div>
          </div>
          <div data-v-6be92187="" class="ivu-col">
            <div data-v-6be92187="" class="history-popper-header-close ivu-row-flex ivu-row-flex-middle ivu-row-flex-center">
              <a data-v-58b7664a="" class="close" @click="closePopover" >
                <!-- <i data-v-6be92187="" class="ivu-icon ivu-icon-md-close" style="font-size: 24px;"></i> -->
                <CloseIcon class="ivu-icon ivu-icon-md-close" style="font-size: 24px;"/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div data-v-6be92187="" class="history-summary ivu-row-flex">
        <div data-v-6be92187="" class="history-summar-cards ivu-col">
          <div data-v-6be92187="" class="history-summary-cards-container ivu-row-flex ivu-row-flex-middle ivu-row-flex-center">
            <div data-v-6be92187="" class="ivu-row-flex" style="margin-left: -6px; margin-right: -6px;">
              <div data-v-6be92187="" class="cir-lay-one">
                <div data-v-6be92187="" class="cir-lay-two">
                  <div data-v-6be92187="" class="cir-lay-thr">
                    <div data-v-6be92187="" class="four"
                      :class="classObject(roundData.score.firstBall)"
                    >
                      <div data-v-6be92187="" class="four-text">
                        <span data-v-6be92187="">
                          {{ roundData.score.firstBall }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-6be92187="" class="cir-lay-one">
                <div data-v-6be92187="" class="cir-lay-two">
                  <div data-v-6be92187="" class="cir-lay-thr">
                    <div v-if="roundData.score.secondBall" data-v-6be92187="" class="four"
                      :class="classObject(roundData.score.secondBall)"
                    >
                      <div data-v-6be92187="" class="four-text">
                        <span data-v-6be92187="">
                          {{ roundData.score.secondBall }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-6be92187="" class="cir-lay-one">
                <div data-v-6be92187="" class="cir-lay-two">
                  <div data-v-6be92187="" class="cir-lay-thr">
                    <div v-if="roundData.score.thirdBall" data-v-6be92187="" class="four"
                      :class="classObject(roundData.score.thirdBall)"
                    >
                      <div data-v-6be92187="" class="four-text">
                        <span data-v-6be92187="">
                          {{ roundData.score.thirdBall }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-v-6be92187="" class="history-summary-result-time ivu-row-flex ivu-row-flex-center">
              {{ roundData.createdDate }}
            </div>
            <div data-v-6be92187="" align="middle" class="result-rows">
              <div data-v-6be92187="" class="second-row-number ivu-row-flex ivu-row-flex-middle ivu-row-flex-center">
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.nextBallOverUnder) }}
                  </div>
                </div>
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.nextBallOddEven) }}
                  </div>
                </div>
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.nextBallRedBlack) }}
                  </div>
                </div>
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.nextBallCombo) }}
                  </div>
                </div>
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.columnBall) }}
                  </div>
                </div>
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.row1Ball) }}
                  </div>
                </div>
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.row3Ball) }}
                  </div>
                </div>
                <div data-v-6be92187="" class="num-ber-result ivu-row">
                  <div data-v-6be92187="" class="ivu-col ivu-col-span-24">
                    {{ $t(roundData.score.row5Ball) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div x-arrow="" class="popper__arrow" style="left: 115px;"></div>
    </div>
  </div>
</template>

<script>
import { isRed } from '@/src/utils/ball.js';
import CloseIcon from '@assets/icons/close.svg';

const RESULT_ARRAY = [
  'bigSmall', 'oddEven', 'redBlack', 'threeRows', 'fiveRows',
];

export default {
  components: {
    CloseIcon,
  },
  props: {
    roundData: {
      type: Object,
      default: () => ({
        name: {
          type: String,
          default: ""
        },
        value: {
          type: String,
          default: ""
        },
        round: {
          type: Number,
          default: 0
        },
        score: {
          type: Object,
          default: () => ({})
        },
        createdDate: {
          type: String,
          default: ""
        },
      })
    }
  },
  mounted() {
    // console.log('[number-result]', this.roundData);
  },
  computed: {
    dices() {
      return Array.from(Array(25).keys());
    },
    tableDices() {
      return this.roundData.score.resultRaw.result;
    },
  },
  methods: {
    closePopover() {
      // console.log('HistoryDetail - closePopover');
      this.$emit('closePopover');
    },
    classSuit: function (value) {

    },
    classWinLoss: function (value) {
      return this.score.result === value ? "bacarat-win" : "bacarat-loss";
    },
    classNumberColor: function (suit) {
      return suit > 2 ? "flipResult-barh-card-number-red" : "flipResult-barh-card-number-black";
    },
    getValue(key) {
      return this.$t('result_map.' + this.roundData.score[key]);
    },
    getItemValue(id) {
      const i = Math.floor(id / 5);
      const j = id % 5;
      const result = this.tableDices[i][j];
      return result;
    },
    classObject (number){
      if(number < 0){
        return '';
      }
      const result = isRed(number);
      return result ? 'redball' : 'blueball';
    },
  }
}
</script>

<style>
   
</style>
